import { render } from "./BrandsLogos.vue?vue&type=template&id=770b9aed&scoped=true"
import script from "./BrandsLogos.vue?vue&type=script&lang=js"
export * from "./BrandsLogos.vue?vue&type=script&lang=js"

import "./BrandsLogos.vue?vue&type=style&index=0&id=770b9aed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770b9aed"]])

export default __exports__